export const InputValidIcon = () => {
  return (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_9_42362)">
        <circle cx="10.5" cy="10" r="10" fill="#59968A" />
      </g>
      <path
        d="M8.93866 14.0697L16.3832 6.62524L15.2755 5.51758L8.93866 11.8544L5.87328 8.78903L4.76562 9.89669L8.93866 14.0697Z"
        fill="white"
      />
      <defs>
        <clipPath id="clip0_9_42362">
          <rect x="0.5" width="20" height="20" rx="10" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
